import actions from './actions';


const initState = {
    lastActionTime: null,
};


export default function activityReducer(state = initState, action) {
    switch (action.type) {
        case actions.UPDATE_LAST_ACTION_TIMESTAMP:
            return {...state, lastActionTime: new Date()}
        default:
            return state;
    }
    return state;
}

